import { createRouter } from 'vue-router'
import { routes as frontRoutes, history, guards as frontGuards } from './front'
import { routes as adminRoutes, guards as adminGuards } from './admin'

export function setupRouter(app) {
  const router = createRouter({
    history: history,
    routes: [...frontRoutes, ...adminRoutes]
  })
  
  // 合并路由守卫
  const guards = [...frontGuards || [], ...adminGuards || []]
  guards.forEach(guard => router.beforeEach(guard))

  app.use(router)
}
